import { writable, get } from "svelte/store"

const initLoc = {
    path: (typeof window !== "undefined" && window.location?.pathname) || "/",
    search: (typeof window !== "undefined" && window.location?.search) || "",
    push: false,
    pop: false,
    categoryPath: "",
}
initLoc.categoryPath = initLoc.path.replace(/\/\d{4,99}[^\/]+$/, "")

export const location = writable(initLoc)

let _apiKey = window.localStorage.getItem("mocoApiKey")
if (!_apiKey || _apiKey == "null") {
    _apiKey = prompt("Moco Api Key")
    window.localStorage.setItem("mocoApiKey", _apiKey)
}

export const apiKey = writable(_apiKey)

let _api2Key = window.localStorage.getItem("wmbasicApiKey")
if (!_api2Key || _api2Key == "null") {
    _api2Key = prompt("WMBasic Api Key")
    window.localStorage.setItem("wmbasicApiKey", _api2Key)
}

export const api2Key = writable(_api2Key)
